export default __webpack_public_path__ + "fbdce63cedc58365ccc31c654420c9e0.png";